import type { ISpotlight } from "./story";
import type { ICitation } from "./citation";
import type { IProcStatus } from "./generic";

export type IImage = {
  guid: string;
  s3Guid: string;
  thumbnailX1: number;
  thumbnailY1: number;
  thumbnailX2: number;
  thumbnailY2: number;
  alt: string;
  index: number;
  imageCitations: ICitation[];
  spotlights: ISpotlight[];
  procStatus: IProcStatus;
};

export type IImageForUpload = {
  thumbnailX1: number;
  thumbnailY1: number;
  thumbnailX2: number;
  thumbnailY2: number;
  alt: string;
  file: File;
};

// External helper function to prepare an image for upload
export function prepImageForUpload(image: IImage, file: File): IImageForUpload {
  return {
    thumbnailX1: image.thumbnailX1,
    thumbnailY1: image.thumbnailY1,
    thumbnailX2: image.thumbnailX2,
    thumbnailY2: image.thumbnailY2,
    alt: image.alt,
    file,
  };
}

// Helper function to append image properties to a FormData object
// NOTE *this is missing index* as index is only needed for places
export function appendImageToFormData(
  formData: FormData,
  image: IImageForUpload,
  fileNameOverride?: string
): FormData {
  formData.append('thumbnailX1', String(image.thumbnailX1));
  formData.append('thumbnailY1', String(image.thumbnailY1));
  formData.append('thumbnailX2', String(image.thumbnailX2));
  formData.append('thumbnailY2', String(image.thumbnailY2));
  formData.append('alt', image.alt);
  formData.append(fileNameOverride ?? 'imageReq', image.file); // File can be appended directly

  return formData;
}
